export const URBAN_VPN_EXTENSION_ID = 'eppiocemhmnlbhjplcgkofciiegomcon';
export const URBAN_VPN_M_ID_MESSAGE =
  "Cannot read properties of undefined (reading 'M_ID')";

export const URBAN_VPN_EXECUTOR_PATH = '/executors/200.js';

type FrameLike = {
  filename?: string;
  abs_path?: string;
};

type ExtensionErrorEventLike = {
  message?: string;
  exception?: {
    values?: Array<{
      value?: string;
      stacktrace?: {
        frames?: FrameLike[];
      };
    }>;
  };
};

function hasUrbanVpnMessage(event: ExtensionErrorEventLike): boolean {
  if (event.message === URBAN_VPN_M_ID_MESSAGE) {
    return true;
  }
  return (
    event.exception?.values?.some(
      (exception) => exception.value === URBAN_VPN_M_ID_MESSAGE,
    ) ?? false
  );
}

function isUrbanVpnFrame(frame: FrameLike): boolean {
  const absPath = frame.abs_path ?? '';
  if (absPath.startsWith(`chrome-extension://${URBAN_VPN_EXTENSION_ID}/`)) {
    return true;
  }
  return (
    absPath.endsWith(URBAN_VPN_EXECUTOR_PATH) ||
    (frame.filename ?? '').endsWith(URBAN_VPN_EXECUTOR_PATH)
  );
}

export function isKnownUrbanVpnExtensionError(event: unknown): boolean {
  if (event === null || typeof event !== 'object') {
    return false;
  }

  const candidate = event as ExtensionErrorEventLike;
  if (!hasUrbanVpnMessage(candidate)) {
    return false;
  }

  return (
    candidate.exception?.values?.some((exception) =>
      exception.stacktrace?.frames?.some(isUrbanVpnFrame),
    ) ?? false
  );
}
